import React, { useRef, useState } from 'react';
import getConfig from 'next/config';
import classnames from 'classnames';

import Button, { ButtonElements, ButtonIconPositions, ButtonIconTypes, ButtonVariants } from 'components/layout/Button';
import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';
import Description from 'components/modules/public/layout/sections/Description';

import { Props } from './index';
import StyledComponent from './styles';

const TextSimpleCmsSection: React.FC<Props> = ({ section }): React.ReactElement => {
    const longDescriptionRef = useRef(null);
    const [expanded, setExpanded] = useState<boolean>(false);
    const { publicRuntimeConfig } = getConfig();
    const appLocale = publicRuntimeConfig.APP_LOCALE;

    const title: string = section?.title;
    const description: string = section?.description;
    const removeParagraph = description.replace(/(<([^>]+)>)/ig, '');

    // based on html with tags length :( instead of clear text
    if (removeParagraph?.length > 640) {
        longDescriptionRef.current = true;
    }

    return (
        <StyledComponent className="public-cms-sections-text-simple-cms-section">
            <LayoutContainer size={Sizes.Large}>
                <Description
                    headline={`<h2>${title}</h2>`}
                    description={description}
                    longDescriptionRef={longDescriptionRef.current}
                    expanded={expanded}
                />
                {longDescriptionRef.current && (
                    <Button
                        className={classnames({
                            'expand-button': true,
                            expanded,
                        })}
                        onClick={() => setExpanded(!expanded)}
                        icon={{
                            value: '/images/home/arrow-down.svg',
                            position: ButtonIconPositions.After,
                            type: ButtonIconTypes.Image,
                        }}
                        variant={ButtonVariants.Outline}
                        element={ButtonElements.Button}

                    >
                        {expanded
                            ? appLocale === 'pl' ? 'Zwiń' : 'Hide'
                            : appLocale === 'pl' ? 'Czytaj wiecej' : 'Read more'
                        }
                    </Button>
                )}
            </LayoutContainer>
        </StyledComponent>
    );
};

export default TextSimpleCmsSection;
